// extracted by mini-css-extract-plugin
export default {"wrapper":"yc","star":"zc","emptyStar":"Ac","filledStar":"Bc","filledStarSvg":"Cc"};